export const demoCompanyCorrelations = {
  "89a0f0a1-9e4a-470a-a899-856ddc4595c8": {
    business: "789f91aa-343d-4521-bab3-5771419d6d94",
    workspace: "43f75949-e96b-472a-b275-31fc567af5e3",
    businessVat: "789f91aa-343d-4521-bab3-5771419d6d94",
    workspaceVat: "urn:ts:digital:registry:items:43f75949-e96b-472a-b275-31fc567af5e3"
    // businessVat: "business0",
    // workspaceVat: "ordinario0"
  },
  "f90b7fcb-7f6f-4c0c-8263-35806f6b8b85": {
    business: "3115a7c3-c812-425a-8b69-0903ee929e05",
    workspace: "8aeb994c-68cf-48b2-b529-3655b0dc8005",
    businessVat: "3115a7c3-c812-425a-8b69-0903ee929e05",
    workspaceVat: "urn:ts:digital:registry:items:8aeb994c-68cf-48b2-b529-3655b0dc8005"
    // businessVat: "business0",
    // workspaceVat: "agricolo0"
  },
  // dev
  "5ad40abc-3b67-4f2c-b3ae-8144432b69e6": {
    workspace: "2b2d1e2b-3755-469e-9cf4-d22f66f96b19"
  },
  "b29dda79-ffab-4f5c-9a47-5f4bbfd1e65c": {
    workspace: "2b2d1e2b-3755-469e-9cf4-d22f66f96b19",
    businessVat: "789f91aa-343d-4521-bab3-5771419d6d94",
    workspaceVat: "urn:ts:digital:registry:items:43f75949-e96b-472a-b275-31fc567af5e3"
  },
  "aac8303b-4313-4b20-8add-cd51fac0a7d5": {
    workspace: "2b2d1e2b-3755-469e-9cf4-d22f66f96b19"
  }
};
